<template>
  <report-container
    v-if="currentPageName === 'time-rollup'"
    :actions="actions"
  >
    <template v-slot:report-modals>
      <time-modal />
    </template>
  </report-container>
</template>

<script>
import mixin from 'src/utils/mixin'

export default {
  name: 'TimeRollup',
  components: {
    TimeModal: () => import('src/internal/components/TimeModal'),
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'internal/openTimeEntryFormUpdate',
          name: 'Edit',
        },
        {
          event: 'internal/openTimeEntryFormDelete',
          name: 'Delete',
        },
      ],
    }
  },
}
</script>
